import React  from 'react';
//前言

const Enclosure42 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>第一条 下列各款均定义为交通事故：</h3>
            <p>1.车辆相撞造成双方或一方有损害伤亡的。</p>
            <p>2.车辆撞及人畜、路旁建筑物及其他物品，造成损害伤亡的.</p>
            <p>3.车辆行驶中因驾驶员操作不当或不慎翻车，造成车辆人员损害伤亡的。</p>
            <p>4.车辆行驶中遇到意外情况，如公路、桥梁、隧道突然崩蹋、损坏造成车辆人员损害伤亡的。</p>
            <br/>
            <h3>第二条 发生交通事故后驾驶员应立即停车，抢救伤者和财产，保护现场，必须移动时应当标明位置，并迅速报告公安机关或者执勤的交通警察，听候处理；事故发生后驾驶员必须迅速以电话通知公司并向保险公司报案。</h3>
            <br/>
            <h3>第三条 公司接到事故通知时，应立即向各管理公司总经理报告，并迅速安排有关人员前往事故地点协助处理有关事宜。</h3>
            <br/>
            <h3>第四条 发生交通事故后驾驶员应尽量记录下列信息：</h3>
            <p>1、事故发生的地点、时间、气候。</p>
            <p>2、事故发生的原因。</p>
            <p>3、对方车号、驾驶员的姓名、住址、电话。</p>
            <p>4、损害情形，包括对方车辆及乘客财产的损失。</p>
            <p>5、伤亡人员姓名、地址及伤亡原因与情形和救护的方法。</p>
            <br/>
            <h3>第五条 事故处理</h3>
            <p>1、对造成交通事故的驾驶员的处理办法，由行政机构与事故所属部门组成交通事故处理小组，共同商讨决定。</p>
            <p>2、事故发生后必须立即抢救伤者，抢救的医疗费用可由公司先行垫付。</p>
            <p>3、交通事故的刑事责任由驾驶员本人承担。</p>
            <p>4、发生交通事故后驾驶员被法院判刑的，自判决之日起驾驶员与公司的劳动合同自动解除，但应由驾驶员承担的民事赔偿责任继续由其本人承担。</p>
            <p>5、发生事故后畏罪潜逃的，除请司法机关缉办外，并立即予以解雇。</p>
            <p>6、公司员工违反国家法律、法规及公司的规章制度，如无证驾驶和酒后开车造成的交通事故，其民事刑事责任全部由肇事驾驶员本人承担，公司还将根据情节轻重对驾驶员分别处以警告、严重警告、解除劳动合同的处分，并及10000元的处罚。</p>
            <p>7、驾驶人员有权拒绝违章指挥。若对于违章指挥驾驶人员没有拒绝的，所造成交通事故由驾驶员本人负全责（包括民事赔偿和刑事责任）。并根据情节轻重对驾驶员分别处以警告、严重警告、解除劳动合同的处分，并及200—2000元的处罚。</p>
            <p>8、驾驶员私自将车辆交给不适宜驾车的人员造成的交通事故，借车人和肇事人负同等民事赔偿责任，另据情节轻重对借车人分别处以警告、严重警告、解除劳动合同的处分，并及200—2000元的处罚。</p>
            <p>9、事故责任属于对方车辆的，由对方保险公司或对方负责赔偿。未经公司许可，驾驶员不得与对方私了。并根据情节轻重对驾驶员分别处以警告、严重警告、解除劳动合同的处分并及200—2000元的处罚。</p>
            <p>10、事故责任属于公司驾驶员的，赔偿款项由保险公司负担，但超出保险理赔范围的部分，由肇事驾驶员承担损失的40%，驾驶员部门负责人承担30%，管理公司第一责权人承担30%；并分别处以500—5000元的处罚。</p>
            <p>11.事故责任属于公司驾驶员与对方驾驶员或第三者共同过失的，按各方应负责任之比率分担，超出保险理赔范围的部分，由肇事驾驶员承担损失的40%，驾驶员部门负责人承担30%，管理公司第一责权人承担30%；并分别处以200—2000元的处罚。</p>
            <p>12.事故发生后对方车辆逃逸能制止而未制止，或对方车号能注意而未注意，致使事故责任无法判断或追究的，所造成的损害赔偿，由肇事驾驶员负责参照前款（第五条第10项）处理。</p>
            <p>13.事故发生的原因经查明属于不可抗力，无法避免的，由保险公司承担赔偿责任，超出保险理赔范围的部分，由公司负担。</p>
            <br/>
            <h3>第六条 本办法如有未尽事宜或有与国家法律法规相违背之处，以国家法律法规为准。</h3>
            <br/><br/>
        </div>
    </div>



export default Enclosure42;